/*doc

Displays a user’s book recommendations. This component is used on the home page.

We have eight different recommendation algorithms for this widget. We first
randomly choose one of six algorithms which are based on the user's shelvings.
Those correspond with the following algorithm ids:

0: recs are based on the genre of a book the user is currently reading
1: recs are based on books similar to a book the user is currently reading
2: recs are based on the genre of a book the user recently read
3: recs are based on books similar to a book the user recently read
4: recs are based on the genre of a book the user shelved
5: recs are based on books similar a book the user shelved

If we cannot generate sufficient recs from those algorithms above, we have
generic 'fallback' algorithms. They come in two types:

fav_genres_recs: recs are based on one of the user's favorite genres
shelf_recs: recs are based on one of the user's shelves
*/

import Reflux from "reflux";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { random, isUndefined, includes } from "lodash";
import { ShelvedBookOrigin } from "../../analytics/origins";
import GrComponentFactory from "../gr_component_factory";
import BookDescription from "../book_description";
import Book from "../book";
import CommunityRating from "../community_rating";
import WantToReadButton from "../want_to_read/want_to_read_button";
import RecommendationsStore from "../../react_stores/recommendations_store";
import RecommendationsActions from "../../react_actions/recommendations_actions";
import { truncateBookTitle } from "../../modules/reading_session_helper";

const REC_ALGORITHM_IDS = {
  CURRENTLY_READING: [0, 1],
  RECENTLY_READ: [2, 3],
  SHELVED: [4, 5],
  GENRES: [0, 2, 4],
};

export const FALLBACK_RECS = {
  FAV_GENRE_RECS: "fav_genres_recs",
  SHELF_RECS: "shelf_recs",
};

const transitionTimeout = 300;

export default GrComponentFactory.createClass({
  displayName: "Recommendations",

  mixins: [Reflux.connect(RecommendationsStore, "recommendationsStore")],

  boldLink(linkUrl, linkText) {
    return <a href={linkUrl}
              className="gr-hyperlink gr-hyperlink--bold">
      {linkText}
    </a>;
  },

  renderJustificationText() {
    const state = this.state.recommendationsStore;
    return (
      <div className="recommendationsWidget__justificationText">
      { state.fallbackRecsType ?
        this.renderGenericRationaleText() : this.renderShelvingRationaleText() }
      </div>
    );
  },

  renderGenericRationaleText() {
    const state = this.state.recommendationsStore;
    if (state.fallbackRecsType === FALLBACK_RECS.FAV_GENRE_RECS) {
      return (
        <span>
          A few recommendations for you in
          { state.genre.url ?
            <span> {this.boldLink(state.genre.url, state.genre.name)}</span> :
            <span> {state.genre.name}</span>
          }
        </span>
      );
    } else {
      return (
        <span>Based on
          your {this.boldLink(state.recShelf.url, `${state.recShelf.name} shelf`)} a few recommendations:
        </span>
      );
    }
  },

  getShelvingDescription() {
    const state = this.state.recommendationsStore;
    if (includes(REC_ALGORITHM_IDS.CURRENTLY_READING, state.algorithmId)) {
      return "Because you are currently reading ";
    } else if (includes(REC_ALGORITHM_IDS.RECENTLY_READ, state.algorithmId)) {
      if (state.recBook.currentUserRating < 3) {
        return "Because you read ";
      } else {
        return "Because you enjoyed ";
      }
    } else {
      return "Because you shelved ";
    }
  },

  renderShelvingRationaleText() {
    const state = this.state.recommendationsStore;
    const shelvingDescription = this.getShelvingDescription();
    const bookLink = this.boldLink(state.recBook.url, truncateBookTitle(state.recBook.title));

    return <span>
            { shelvingDescription }{ bookLink }:
           </span>;
  },

  renderBookDisplay(book) {
    return (
      <div className="recommendationsWidget__rec u-marginTopXSmall" key={book.bookId}>
        <div className="recommendationsWidget__bookWrapper">
          <Book {...book}>
            <CommunityRating
              rating={parseFloat(book.avgRating)}
              displayAvg={true}/>
            <div className="u-marginTopXSmall">
              <WantToReadButton
                bookTitle={book.title}
                uniqueId={random(1000000).toString()}
                bookId={book.bookId}
                origin={ShelvedBookOrigin.RECS_WIDGET}
                showMenu={false}/>
            </div>
          </Book>
        </div>
        { this.renderBookDescription(book) }
        { this.renderCaret() }
      </div>
    );
  },

  renderBookDescription(book) {
    if (!isUndefined(book.description)) {
      return <BookDescription bookDescription={book.description} />;
    } else {
      return null;
    }
  },

  renderCaret() {
    return (
      <button className="gr-button
                         gr-button--caretRight
                         recommendationsWidget__caret"
              aria-label="Next Recommendation"
              onClick={RecommendationsActions.requestNextRec} />
    );
  },

  renderRecommendationsLink() {
    const state = this.state.recommendationsStore;
    if (!state.fallbackRecsType) {
      return (
          <a className="recommendationsWidget__viewAll" href={state.recBook.similarBooksUrl}>
            View all books similar to {truncateBookTitle(state.recBook.title)}
          </a>
      );
    } else if (state.fallbackRecsType === FALLBACK_RECS.FAV_GENRE_RECS && state.genre.similarBooksUrl) {
      return (
          <a className="recommendationsWidget__viewAll" href={state.genre.similarBooksUrl}>
            View similar books in this genre
          </a>
      );
    } else {
      return (
          <a className="recommendationsWidget__viewAll" href="/recommendations">
            View all recommendations
          </a>
      );
    }
  },

  render() {
    const state = this.state.recommendationsStore;
    const activeRecommendation =
      state.recommendations[state.activeRecommendationId];
    return (
      <div className="recommendationsWidget">
        <h3 className="gr-h3 gr-h3--noTopMargin">Recommendations</h3>
        { this.renderJustificationText() }
        <ReactCSSTransitionGroup transitionName="recommendationsWidget__rec"
                                 transitionEnterTimeout={transitionTimeout}
                                 transitionLeaveTimeout={transitionTimeout}>
          { this.renderBookDisplay(activeRecommendation.book) }
        </ReactCSSTransitionGroup>
        <div className="u-marginTopXSmall"> { this.renderRecommendationsLink() } </div>
      </div>
    );
  },
});
